export default "__VITE_ASSET__C2O55tWL__"